import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export function BottomSheet({ open, onClose, title, children, height, leftAction, fill }) {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className="fixed inset-0 z-[60]"
            style={{ background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            data-testid="sheet-backdrop"
          />
          <motion.div
            className="fixed left-0 right-0 bottom-0 z-[70] mx-auto glass rounded-t-3xl flex flex-col fv-sheet"
            style={{ maxWidth: 480, height: height || undefined, maxHeight: height ? height : "90dvh" }}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 30, stiffness: 300 }}
          >
            <div className="flex flex-col flex-1 min-h-0 w-full lg:max-w-6xl lg:mx-auto">
              <div className="flex items-center justify-between px-5 pt-4 pb-3 lg:pt-6 shrink-0">
                {leftAction || <div className="w-10" />}
                <div className="fv-sheet-drag mx-auto h-1.5 w-12 rounded-full absolute left-1/2 -translate-x-1/2 top-2" style={{ background: "var(--text-muted)", opacity: 0.4 }} />
                <h3 className="font-serif-display text-2xl lg:text-3xl" style={{ color: "var(--text-primary)" }}>
                  {title}
                </h3>
                <button
                  onClick={onClose}
                  className="p-2 rounded-full hover:bg-white/10 transition-colors"
                  data-testid="sheet-close-btn"
                >
                  <X size={20} />
                </button>
              </div>
              <div className={fill
                ? "px-5 pb-4 flex-1 min-h-0 flex flex-col"
                : "px-5 pb-8 overflow-y-auto overflow-x-hidden no-scrollbar flex-1 min-h-0"}
                style={fill ? { paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 0.75rem)" } : { paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 2rem)" }}>
                {children}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
